import { render } from "./Contact.vue?vue&type=template&id=2d220f4f&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=2d220f4f&scoped=true&lang=scss"

import exportComponent from "/Users/skynet/Documents/Sites safe 2026/Safe_Sites_Modifs/SAFE_GROUP/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d220f4f"]])

export default __exports__